import { queryOptions } from '@tanstack/react-query';
import { getApartmentDebug } from '@/api/generated/sdk.gen';
import type { ApartmentDebug } from '@/api/generated/types.gen';

export type { ApartmentDebug };

// Same retry policy as the other apartment-scoped queries (see
// apartmentChannelEventsQuery in lib/channels.ts): don't retry on 401/404,
// retry once on anything else.
const retryFn = (failureCount: number, err: unknown) => {
  const status = (err as { status?: number })?.status;
  return status !== 401 && status !== 404 && failureCount < 1;
};

// apartmentDebugQuery — the operator diagnostics panel (GET
// /apartments/{id}/debug, gated on debug.read). Read-only: this file has no
// mutations, mirroring the fact that DebugSection never writes anything.
export const apartmentDebugQuery = (apartmentID: string) =>
  queryOptions({
    queryKey: ['apartments', apartmentID, 'debug'],
    queryFn: async ({ signal }) => {
      const res = await getApartmentDebug({
        throwOnError: true,
        signal,
        path: { id: apartmentID },
      });
      return res.data;
    },
    retry: retryFn,
    staleTime: 10_000,
  });
